export const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'About Us',
      services: 'Services',
      subsidy: 'Subsidy',
      projects: 'Projects',
      contact: 'Contact',
      callNow: 'Call Now'
    },
    
    // Home Page
    home: {
      heroTitle: 'Affordable Solar Panel Installation for Rural & Urban India',
      heroSubtitle: 'Save electricity bills with clean, reliable solar energy. Serving Gorakhpur and surrounding areas with certified installation and maintenance.',
      freeSurvey: 'Get Free Site Survey',
      whyChooseTitle: 'Why Choose Agri Solar Solution',
      certified: 'Certified Solar Experts',
      affordable: 'Affordable Pricing',
      subsidy: 'Government Subsidy Support',
      installation: 'Installation in Villages & Cities',
      servicesTitle: 'Our Services',
      viewAll: 'View All Services',
      benefitsTitle: 'Benefits of Solar Energy',
      save90: 'Save up to 90%',
      save90Desc: 'Reduce electricity bills dramatically',
      lowMaintenance: 'Low Maintenance',
      lowMaintenanceDesc: 'Minimal upkeep, maximum efficiency',
      longLife: '25+ Years Life',
      longLifeDesc: 'Long-lasting, reliable panels',
      ecoFriendly: 'Eco-Friendly',
      ecoFriendlyDesc: 'Clean, renewable energy',
      ctaTitle: 'Switch to Solar Today',
      ctaSubtitle: 'Join thousands of satisfied customers in Gorakhpur and surrounding areas who have made the switch to clean, affordable solar energy.',
      whatsappUs: 'WhatsApp Us',
      call: 'Call'
    },
    
    // Services
    services: {
      title: 'Our Solar Services',
      subtitle: 'Comprehensive solar solutions for homes, businesses, and farms across Gorakhpur and surrounding areas.',
      residential: 'Residential Solar',
      residentialDesc: 'Transform your home with rooftop solar panels designed for Indian households',
      commercial: 'Commercial Solar',
      commercialDesc: 'High-capacity solar solutions for businesses, offices, and institutions',
      rural: 'Rural Solar Solutions',
      ruralDesc: 'Empowering villages and farms with reliable, off-grid solar power',
      maintenance: 'Solar Maintenance & AMC',
      maintenanceDesc: 'Keep your solar system running at peak performance',
      rooftopInstall: 'Rooftop solar panel installation',
      onGrid: 'On-grid and hybrid systems',
      idealHomes: 'Ideal for homes and apartments',
      subsidyAssist: 'Government subsidy assistance',
      netMetering: 'Net metering setup',
      largeScale: 'Large-scale installations',
      perfectFor: 'Perfect for offices, factories, schools',
      costSavings: 'Significant cost savings',
      customDesign: 'Custom capacity design',
      monitoring: 'Professional monitoring systems',
      offGrid: 'Off-grid solar systems',
      waterPumps: 'Solar water pumps for agriculture',
      villageHomes: 'Village home installations',
      noDependency: 'No dependency on grid power',
      ruralPackages: 'Special rural packages',
      amc: 'Annual maintenance contracts',
      panelCleaning: 'Regular panel cleaning',
      inverterCheckup: 'Inverter checkups and repairs',
      performance: 'Performance monitoring',
      support247: '24/7 support hotline',
      readyTitle: 'Ready to Go Solar?',
      readySubtitle: 'Get a free site survey and customized solar solution for your needs',
      freeConsult: 'Get Free Consultation'
    },
    
    // About
    about: {
      title: 'About Agri Solar Solution',
      subtitle: 'Leading solar panel installation company serving Gorakhpur and surrounding areas with a commitment to clean, affordable energy for all.',
      storyTitle: 'Our Story',
      story1: 'Agri Solar Solution was founded with a clear purpose: to bring the benefits of solar energy to every corner of India, from bustling urban centers to remote rural villages.',
      story2: 'We understand the unique challenges faced by communities in Uttar Pradesh and surrounding regions. High electricity bills, frequent power cuts, and limited access to reliable energy sources inspired us to create solutions that work for everyone.',
      story3: 'With years of experience in solar installation and a deep commitment to customer satisfaction, we\'ve helped hundreds of families, farmers, and businesses transition to clean, cost-effective solar power.',
      mission: 'Our Mission',
      missionText: 'Making affordable solar energy accessible to every home, farm, and business in rural and urban India',
      vision: 'Our Vision',
      visionText: 'Achieving energy independence for India through widespread adoption of clean, renewable solar power',
      whyRuralTitle: 'Why We Focus on Rural Areas',
      powerAccess: 'Power Access',
      powerAccessDesc: 'Many rural areas face irregular power supply. Solar provides reliable, independent energy access 24/7.',
      farmerEmp: 'Farmer Empowerment',
      farmerEmpDesc: 'Solar water pumps and farm equipment powered by solar help increase agricultural productivity and reduce costs.',
      govSupport: 'Government Support',
      govSupportDesc: 'We help rural communities access government subsidies and schemes designed to promote renewable energy adoption.',
      valuesTitle: 'Our Core Values',
      quality: 'Quality',
      qualityDesc: 'Premium solar panels with 25+ years warranty',
      community: 'Community Focus',
      communityDesc: 'Empowering villages and cities with clean energy',
      expertise: 'Expertise',
      expertiseDesc: 'Certified professionals with years of experience',
      customerCare: 'Customer Care',
      customerCareDesc: 'Dedicated support throughout your solar journey'
    },
    
    // Subsidy
    subsidy: {
      title: 'Solar Subsidy & Benefits',
      subtitle: 'Take advantage of government subsidies and financial incentives to make solar energy even more affordable.',
      govSubsidyTitle: 'Government Rooftop Solar Subsidy',
      govSubsidyDesc: 'The Ministry of New and Renewable Energy (MNRE) offers subsidies for residential rooftop solar installations across India, including Uttar Pradesh.',
      assistanceNote: 'We assist you with complete documentation and subsidy application process at no extra cost.',
      subsidyStructure: 'Subsidy Structure',
      systemCapacity: 'System Capacity',
      centerSubsidy: 'Central Government Subsidy',
      stateSubsidy: 'State Government Subsidy',
      totalSubsidy: 'Total Subsidy',
      above3kw: 'Above 3 kW',
      financialBenefits: 'Financial Benefits',
      lowerCost: 'Lower Initial Cost',
      lowerCostDesc: 'Government subsidy reduces upfront installation cost significantly',
      fasterROI: 'Faster ROI',
      fasterROIDesc: 'Recover your investment in 3-5 years instead of 7-8 years',
      monthlySavings: 'Monthly Savings',
      monthlySavingsDesc: 'Save up to 90% on electricity bills every month',
      netMetering: 'Net Metering',
      netMeteringDesc: 'Sell excess power back to the grid and earn credits',
      estimatedSavings: 'Estimated Savings',
      withoutSolar: 'Without Solar',
      avgBill: 'Average monthly electricity bill',
      withSolar: 'With Solar',
      reducedCharges: 'Reduced to minimal grid charges',
      annualSavings: 'Annual Savings: ₹30,000 - ₹50,000+',
      yearsSavings: 'Over 25 years, save ₹7,50,000 - ₹12,50,000 or more!',
      docsRequired: 'Required Documents for Subsidy',
      aadhaar: 'Aadhaar Card',
      electricityBill: 'Electricity Bill (recent)',
      propertyProof: 'Property ownership proof',
      bankDetails: 'Bank account details',
      photos: 'Passport size photographs',
      addressProof: 'Address proof',
      docsHelp: 'We help you prepare and submit all documentation for hassle-free subsidy approval.'
    },
    
    // Projects
    projects: {
      title: 'Our Projects',
      subtitle: 'Explore our successful solar installations across Gorakhpur and surrounding areas',
      allProjects: 'All Projects',
      residential: 'Residential',
      commercial: 'Commercial',
      rural: 'Rural',
      noProjects: 'No projects found in this category.'
    },
    
    // Contact
    contact: {
      title: 'Contact Us',
      subtitle: 'Get in touch for a free site survey and customized solar solution',
      getInTouch: 'Get In Touch',
      intro: 'We\'re here to help you make the switch to solar energy. Reach out to us through any of these channels.',
      phone: 'Phone',
      whatsapp: 'WhatsApp',
      chatWithUs: 'Chat with us',
      email: 'Email',
      address: 'Address',
      serviceArea: 'Service Area',
      serviceAreaDesc: 'We serve Gorakhpur city and all areas within a 50KM radius, including rural villages and nearby towns.',
      sendMessage: 'Send Us a Message',
      formIntro: 'Fill out the form below and we\'ll get back to you within 24 hours.',
      thankYou: 'Thank you for your inquiry!',
      contactSoon: 'We\'ll contact you soon to discuss your solar needs.',
      name: 'Name',
      namePlaceholder: 'Your full name',
      phoneNumber: 'Phone Number',
      phonePlaceholder: 'Your contact number',
      cityVillage: 'City/Village',
      cityPlaceholder: 'Your location',
      message: 'Message',
      messagePlaceholder: 'Tell us about your solar requirements...',
      submitInquiry: 'Submit Inquiry',
      findUs: 'Find Us',
      addressFull: 'Police Chowki Jharna Tola, Nena Thapa Road, Near Jai Mata Di Marriage Hall, Gorakhpur, UP - 273008'
    },
    
    // Footer
    footer: {
      description: 'Affordable solar panel installation for rural & urban India. Empowering communities with clean, reliable energy.',
      quickLinks: 'Quick Links',
      ourServices: 'Our Services',
      residentialSolar: 'Residential Solar',
      commercialSolar: 'Commercial Solar',
      ruralSolar: 'Rural Solar Systems',
      maintenance: 'Maintenance & AMC',
      contactUs: 'Contact Us',
      copyright: 'Agri Solar Solution. All rights reserved.',
      serviceArea: 'Serving Gorakhpur and surrounding areas (50KM radius)'
    },
    
    // Common
    common: {
      readMore: 'Read More',
      learnMore: 'Learn More',
      getStarted: 'Get Started',
      contactUs: 'Contact Us',
      call: 'Call',
      required: 'Required'
    }
  },
  
  hi: {
    // Navigation
    nav: {
      home: 'होम',
      about: 'हमारे बारे में',
      services: 'सेवाएं',
      subsidy: 'सब्सिडी',
      projects: 'प्रोजेक्ट्स',
      contact: 'संपर्क करें',
      callNow: 'कॉल करें'
    },
    
    // Home Page
    home: {
      heroTitle: 'ग्रामीण और शहरी भारत के लिए किफायती सोलर पैनल इंस्टॉलेशन',
      heroSubtitle: 'स्वच्छ, विश्वसनीय सौर ऊर्जा के साथ बिजली के बिल बचाएं। गोरखपुर और आसपास के क्षेत्रों में प्रमाणित स्थापना और रखरखाव के साथ सेवा प्रदान करना।',
      freeSurvey: 'मुफ्त साइट सर्वे पाएं',
      whyChooseTitle: 'अग्रि सोलर सॉल्यूशन क्यों चुनें',
      certified: 'प्रमाणित सोलर विशेषज्ञ',
      affordable: 'किफायती कीमत',
      subsidy: 'सरकारी सब्सिडी सहायता',
      installation: 'गांवों और शहरों में स्थापना',
      servicesTitle: 'हमारी सेवाएं',
      viewAll: 'सभी सेवाएं देखें',
      benefitsTitle: 'सौर ऊर्जा के लाभ',
      save90: '90% तक बचत',
      save90Desc: 'बिजली के बिल में नाटकीय रूप से कमी',
      lowMaintenance: 'कम रखरखाव',
      lowMaintenanceDesc: 'न्यूनतम देखभाल, अधिकतम दक्षता',
      longLife: '25+ साल की लाइफ',
      longLifeDesc: 'दीर्घकालिक, विश्वसनीय पैनल',
      ecoFriendly: 'पर्यावरण के अनुकूल',
      ecoFriendlyDesc: 'स्वच्छ, नवीकरणीय ऊर्जा',
      ctaTitle: 'आज ही सोलर पर स्विच करें',
      ctaSubtitle: 'गोरखपुर और आसपास के क्षेत्रों में हजारों संतुष्ट ग्राहकों के साथ जुड़ें जिन्होंने स्वच्छ, किफायती सौर ऊर्जा पर स्विच किया है।',
      whatsappUs: 'व्हाट्सएप करें',
      call: 'कॉल'
    },
    
    // Services
    services: {
      title: 'हमारी सोलर सेवाएं',
      subtitle: 'गोरखपुर और आसपास के क्षेत्रों में घरों, व्यवसायों और खेतों के लिए व्यापक सौर समाधान।',
      residential: 'आवासीय सोलर',
      residentialDesc: 'भारतीय घरों के लिए डिज़ाइन किए गए रूफटॉप सोलर पैनल के साथ अपने घर को बदलें',
      commercial: 'व्यावसायिक सोलर',
      commercialDesc: 'व्यवसायों, कार्यालयों और संस्थानों के लिए उच्च क्षमता वाले सौर समाधान',
      rural: 'ग्रामीण सोलर सॉल्यूशन',
      ruralDesc: 'विश्वसनीय, ऑफ-ग्रिड सौर ऊर्जा के साथ गांवों और खेतों को सशक्त बनाना',
      maintenance: 'सोलर रखरखाव और AMC',
      maintenanceDesc: 'अपनी सौर प्रणाली को शिखर प्रदर्शन पर चलाते रहें',
      rooftopInstall: 'रूफटॉप सोलर पैनल स्थापना',
      onGrid: 'ऑन-ग्रिड और हाइब्रिड सिस्टम',
      idealHomes: 'घरों और अपार्टमेंट के लिए आदर्श',
      subsidyAssist: 'सरकारी सब्सिडी सहायता',
      netMetering: 'नेट मीटरिंग सेटअप',
      largeScale: 'बड़े पैमाने पर स्थापना',
      perfectFor: 'कार्यालयों, कारखानों, स्कूलों के लिए बिल्कुल सही',
      costSavings: 'महत्वपूर्ण लागत बचत',
      customDesign: 'कस्टम क्षमता डिजाइन',
      monitoring: 'पेशेवर निगरानी प्रणाली',
      offGrid: 'ऑफ-ग्रिड सोलर सिस्टम',
      waterPumps: 'कृषि के लिए सोलर वाटर पंप',
      villageHomes: 'गांव घर स्थापना',
      noDependency: 'ग्रिड पावर पर कोई निर्भरता नहीं',
      ruralPackages: 'विशेष ग्रामीण पैकेज',
      amc: 'वार्षिक रखरखाव अनुबंध',
      panelCleaning: 'नियमित पैनल सफाई',
      inverterCheckup: 'इन्वर्टर चेकअप और मरम्मत',
      performance: 'प्रदर्शन निगरानी',
      support247: '24/7 सपोर्ट हॉटलाइन',
      readyTitle: 'सोलर के लिए तैयार हैं?',
      readySubtitle: 'अपनी आवश्यकताओं के लिए मुफ्त साइट सर्वे और अनुकूलित सौर समाधान प्राप्त करें',
      freeConsult: 'मुफ्त परामर्श पाएं'
    },
    
    // About
    about: {
      title: 'अग्रि सोलर सॉल्यूशन के बारे में',
      subtitle: 'गोरखपुर और आसपास के क्षेत्रों में अग्रणी सोलर पैनल स्थापना कंपनी, सभी के लिए स्वच्छ, किफायती ऊर्जा के प्रति प्रतिबद्धता के साथ।',
      storyTitle: 'हमारी कहानी',
      story1: 'अग्रि सोलर सॉल्यूशन की स्थापना एक स्पष्ट उद्देश्य के साथ की गई थी: भारत के हर कोने में सौर ऊर्जा के लाभ लाना, हलचल भरे शहरी केंद्रों से लेकर दूरदराज के ग्रामीण गांवों तक।',
      story2: 'हम उत्तर प्रदेश और आसपास के क्षेत्रों में समुदायों द्वारा सामना की जाने वाली अनूठी चुनौतियों को समझते हैं। उच्च बिजली बिल, बार-बार बिजली कटौती, और विश्वसनीय ऊर्जा स्रोतों तक सीमित पहुंच ने हमें सभी के लिए काम करने वाले समाधान बनाने के लिए प्रेरित किया।',
      story3: 'सोलर स्थापना में वर्षों के अनुभव और ग्राहक संतुष्टि के प्रति गहरी प्रतिबद्धता के साथ, हमने सैकड़ों परिवारों, किसानों और व्यवसायों को स्वच्छ, लागत प्रभावी सौर ऊर्जा में संक्रमण में मदद की है।',
      mission: 'हमारा मिशन',
      missionText: 'ग्रामीण और शहरी भारत में हर घर, खेत और व्यवसाय के लिए किफायती सौर ऊर्जा सुलभ बनाना',
      vision: 'हमारी दृष्टि',
      visionText: 'स्वच्छ, नवीकरणीय सौर ऊर्जा को व्यापक रूप से अपनाने के माध्यम से भारत के लिए ऊर्जा स्वतंत्रता प्राप्त करना',
      whyRuralTitle: 'हम ग्रामीण क्षेत्रों पर ध्यान क्यों देते हैं',
      powerAccess: 'बिजली पहुंच',
      powerAccessDesc: 'कई ग्रामीण क्षेत्रों में अनियमित बिजली आपूर्ति का सामना करना पड़ता है। सोलर 24/7 विश्वसनीय, स्वतंत्र ऊर्जा पहुंच प्रदान करता है।',
      farmerEmp: 'किसान सशक्तिकरण',
      farmerEmpDesc: 'सोलर द्वारा संचालित सोलर वाटर पंप और कृषि उपकरण कृषि उत्पादकता बढ़ाने और लागत कम करने में मदद करते हैं।',
      govSupport: 'सरकारी सहायता',
      govSupportDesc: 'हम ग्रामीण समुदायों को नवीकरणीय ऊर्जा अपनाने को बढ़ावा देने के लिए डिज़ाइन की गई सरकारी सब्सिडी और योजनाओं तक पहुंचने में मदद करते हैं।',
      valuesTitle: 'हमारे मूल मूल्य',
      quality: 'गुणवत्ता',
      qualityDesc: '25+ साल की वारंटी के साथ प्रीमियम सोलर पैनल',
      community: 'सामुदायिक फोकस',
      communityDesc: 'स्वच्छ ऊर्जा के साथ गांवों और शहरों को सशक्त बनाना',
      expertise: 'विशेषज्ञता',
      expertiseDesc: 'वर्षों के अनुभव के साथ प्रमाणित पेशेवर',
      customerCare: 'ग्राहक देखभाल',
      customerCareDesc: 'आपकी सौर यात्रा के दौरान समर्पित सहायता'
    },
    
    // Subsidy
    subsidy: {
      title: 'सोलर सब्सिडी और लाभ',
      subtitle: 'सौर ऊर्जा को और अधिक किफायती बनाने के लिए सरकारी सब्सिडी और वित्तीय प्रोत्साहनों का लाभ उठाएं।',
      govSubsidyTitle: 'सरकारी रूफटॉप सोलर सब्सिडी',
      govSubsidyDesc: 'नवीन और नवीकरणीय ऊर्जा मंत्रालय (MNRE) उत्तर प्रदेश सहित पूरे भारत में आवासीय रूफटॉप सौर प्रतिष्ठानों के लिए सब्सिडी प्रदान करता है।',
      assistanceNote: 'हम बिना किसी अतिरिक्त लागत के पूर्ण दस्तावेज़ीकरण और सब्सिडी आवेदन प्रक्रिया में आपकी सहायता करते हैं।',
      subsidyStructure: 'सब्सिडी संरचना',
      systemCapacity: 'सिस्टम क्षमता',
      centerSubsidy: 'केंद्र सरकार सब्सिडी',
      stateSubsidy: 'राज्य सरकार सब्सिडी',
      totalSubsidy: 'कुल सब्सिडी',
      above3kw: '3 kW से ऊपर',
      financialBenefits: 'वित्तीय लाभ',
      lowerCost: 'कम प्रारंभिक लागत',
      lowerCostDesc: 'सरकारी सब्सिडी अग्रिम स्थापना लागत को काफी कम कर देती है',
      fasterROI: 'तेजी से ROI',
      fasterROIDesc: '7-8 साल के बजाय 3-5 साल में अपने निवेश की वसूली करें',
      monthlySavings: 'मासिक बचत',
      monthlySavingsDesc: 'हर महीने बिजली के बिल पर 90% तक की बचत करें',
      netMetering: 'नेट मीटरिंग',
      netMeteringDesc: 'अतिरिक्त बिजली को वापस ग्रिड में बेचें और क्रेडिट अर्जित करें',
      estimatedSavings: 'अनुमानित बचत',
      withoutSolar: 'सोलर के बिना',
      avgBill: 'औसत मासिक बिजली बिल',
      withSolar: 'सोलर के साथ',
      reducedCharges: 'न्यूनतम ग्रिड शुल्क में कमी',
      annualSavings: 'वार्षिक बचत: ₹30,000 - ₹50,000+',
      yearsSavings: '25 साल में, ₹7,50,000 - ₹12,50,000 या अधिक बचाएं!',
      docsRequired: 'सब्सिडी के लिए आवश्यक दस्तावेज',
      aadhaar: 'आधार कार्ड',
      electricityBill: 'बिजली बिल (हाल ही का)',
      propertyProof: 'संपत्ति स्वामित्व प्रमाण',
      bankDetails: 'बैंक खाता विवरण',
      photos: 'पासपोर्ट साइज फोटो',
      addressProof: 'पता प्रमाण',
      docsHelp: 'हम परेशानी मुक्त सब्सिडी स्वीकृति के लिए सभी दस्तावेज़ तैयार करने और जमा करने में आपकी मदद करते हैं।'
    },
    
    // Projects
    projects: {
      title: 'हमारे प्रोजेक्ट्स',
      subtitle: 'गोरखपुर और आसपास के क्षेत्रों में हमारे सफल सौर प्रतिष्ठानों का अन्वेषण करें',
      allProjects: 'सभी प्रोजेक्ट्स',
      residential: 'आवासीय',
      commercial: 'व्यावसायिक',
      rural: 'ग्रामीण',
      noProjects: 'इस श्रेणी में कोई प्रोजेक्ट नहीं मिला।'
    },
    
    // Contact
    contact: {
      title: 'संपर्क करें',
      subtitle: 'मुफ्त साइट सर्वे और अनुकूलित सौर समाधान के लिए संपर्क करें',
      getInTouch: 'संपर्क में रहें',
      intro: 'हम आपको सौर ऊर्जा पर स्विच करने में मदद करने के लिए यहां हैं। इनमें से किसी भी माध्यम से हमसे संपर्क करें।',
      phone: 'फोन',
      whatsapp: 'व्हाट्सएप',
      chatWithUs: 'हमसे चैट करें',
      email: 'ईमेल',
      address: 'पता',
      serviceArea: 'सेवा क्षेत्र',
      serviceAreaDesc: 'हम गोरखपुर शहर और 50 किमी के दायरे के सभी क्षेत्रों की सेवा करते हैं, जिसमें ग्रामीण गांव और आसपास के शहर शामिल हैं।',
      sendMessage: 'हमें संदेश भेजें',
      formIntro: 'नीचे दिया गया फॉर्म भरें और हम 24 घंटे के भीतर आपसे संपर्क करेंगे।',
      thankYou: 'आपकी पूछताछ के लिए धन्यवाद!',
      contactSoon: 'हम जल्द ही आपकी सौर आवश्यकताओं पर चर्चा करने के लिए आपसे संपर्क करेंगे।',
      name: 'नाम',
      namePlaceholder: 'आपका पूरा नाम',
      phoneNumber: 'फोन नंबर',
      phonePlaceholder: 'आपका संपर्क नंबर',
      cityVillage: 'शहर/गांव',
      cityPlaceholder: 'आपका स्थान',
      message: 'संदेश',
      messagePlaceholder: 'हमें अपनी सौर आवश्यकताओं के बारे में बताएं...',
      submitInquiry: 'पूछताछ सबमिट करें',
      findUs: 'हमें खोजें',
      addressFull: 'पुलिस चौकी झरना टोला, नेना थापा रोड, जय माता दी मैरिज हॉल के पास, गोरखपुर, उत्तर प्रदेश - 273008'
    },
    
    // Footer
    footer: {
      description: 'ग्रामीण और शहरी भारत के लिए किफायती सोलर पैनल स्थापना। स्वच्छ, विश्वसनीय ऊर्जा के साथ समुदायों को सशक्त बनाना।',
      quickLinks: 'त्वरित लिंक',
      ourServices: 'हमारी सेवाएं',
      residentialSolar: 'आवासीय सोलर',
      commercialSolar: 'व्यावसायिक सोलर',
      ruralSolar: 'ग्रामीण सोलर सिस्टम',
      maintenance: 'रखरखाव और AMC',
      contactUs: 'संपर्क करें',
      copyright: 'अग्रि सोलर सॉल्यूशन। सर्वाधिकार सुरक्षित।',
      serviceArea: 'गोरखपुर और आसपास के क्षेत्रों की सेवा (50 किमी के दायरे में)'
    },
    
    // Common
    common: {
      readMore: 'और पढ़ें',
      learnMore: 'और जानें',
      getStarted: 'शुरू करें',
      contactUs: 'संपर्क करें',
      call: 'कॉल',
      required: 'आवश्यक'
    }
  }
};

export const t = (language, key) => {
  const keys = key.split('.');
  let value = translations[language];
  
  for (const k of keys) {
    value = value?.[k];
    if (!value) return key;
  }
  
  return value;
};
